module.exports = __webpack_public_path__ + "24cc936b48f71566b87f50671150d418.pdf";